import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService } from "../core/util/httpManager";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";


export default class ServerTemplateExecuteApp extends React.Component<any, any> {
    common = new AppHelper();
    setTabTitle = this.props.doNotUpdateBrowserTitle;
    translations: StringKeyDictionary<string> = null;
  

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.props.context.translations = this.translations;    
    }

    executeTemplate = () => {      
        if (this.common.validate()) {
            HTTPService.post("ServerTemplate/ExecuteTemplate", { model: this.props.entity})
                .then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                        Helper.updateEntity(this.props.entity, result.Data);
                        this.setState({});
                        this.common.handlePostSave(result.Code === 0, false);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }
    
    componentDidMount() {
        if (this.props.executeTemplate) {
            this.executeTemplate();
        }       
    }
    
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};